var map = {
	"./add.svg": "c2a3",
	"./add2.0.0.svg": "0019",
	"./arrow.svg": "b6e4",
	"./backtop1.svg": "9cc9",
	"./backtop2.svg": "8511",
	"./close.svg": "7710",
	"./close2.0.0.svg": "99ff",
	"./contact_us_icon1.svg": "1fa9",
	"./contact_us_icon2.svg": "c4e7",
	"./customer_service-1.svg": "6cc1",
	"./customer_service.svg": "6562",
	"./down.svg": "d681",
	"./fuwu.svg": "26e2",
	"./headset.svg": "568c",
	"./jd.svg": "16e7",
	"./jdIcon.svg": "ad0a",
	"./kefu.svg": "0063",
	"./left.svg": "d977",
	"./line.svg": "4b7d",
	"./mall.svg": "155f",
	"./menu.svg": "bd3d",
	"./menu2.0.0.svg": "f0b8",
	"./more.svg": "3dd0",
	"./phone.svg": "dd82",
	"./right.svg": "9a71",
	"./server.svg": "cda5",
	"./service.svg": "4e04",
	"./subtraction.svg": "ff3e",
	"./telphone.svg": "bbf3",
	"./tianmao.svg": "39df",
	"./top.svg": "deee",
	"./up.svg": "1380",
	"./weixin.svg": "5afe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";